export const config = {
  features: {
    bidding: false,
  },
};
